import React from 'react';

import { UiFloatingImageBlock } from 'src/graphql/generated/graphql';
import FloatingImageBlock from 'src/components/FloatingImageBlock';

const FloatingImageBlockSection: React.FC<{
  contentBlock: UiFloatingImageBlock;
}> = ({ contentBlock }) => {
  const image = contentBlock.image;
  const backgroundImage = contentBlock.backgroundImage;
  const mobileBackgroundImage = contentBlock.mobileBackgroundImage;
  const textContent = contentBlock.textContent;
  const imagePosition = contentBlock.imagePosition;
  const cta = contentBlock.cta;

  return (
    <FloatingImageBlock
      textContent={textContent}
      imagePosition={imagePosition}
      image={image}
      backgroundImage={backgroundImage}
      mobileBackgroundImage={mobileBackgroundImage}
      cta={cta}
    />
  );
};

export default FloatingImageBlockSection;
